import { NavLink } from 'react-router-dom';

const items = [
  { to: '/tour/machine', icon: 'bi-gear-wide-connected', label: 'Machine' },
  { to: '/tour/documents', icon: 'bi-file-earmark-text', label: 'Documents' },
  { to: '/tour/conversation', icon: 'bi-chat-left-text', label: 'Conversation' },
  { to: '/tour/investigation', icon: 'bi-search', label: 'Investigation' },
  { to: '/tour/memory', icon: 'bi-cpu', label: 'Machine Memory' },
  { to: '/tour/activity', icon: 'bi-clock-history', label: 'Activity' },
] as const;

export function TourSidebar({ machineName }: { machineName: string }) {
  return (
    <aside className="r42-sidebar r42-tour-sidebar">
      <div className="r42-sidebar-machine">
        <span className="r42-eyebrow">Guided example</span>
        <strong>{machineName}</strong>
      </div>
      <nav className="r42-nav" aria-label="Product Tour navigation">
        <span className="r42-nav-label">Example workspace</span>
        {items.map((item) => (
          <NavLink key={item.to} className={({ isActive }) => `r42-nav-item${isActive ? ' active' : ''}`} to={item.to}>
            <i className={`bi ${item.icon}`} aria-hidden="true" /> {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="r42-tour-sidebar__note">
        <i className="bi bi-shield-check" aria-hidden="true" />
        <span>This example is isolated from your organization's machine data.</span>
      </div>
    </aside>
  );
}
